import { TextField } from 'mui-rff';
import React from 'react';

import SenderSelectField from '@dashboard/components/form-fields/SenderSelectField';
import { HelpOutlineOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import PreviewButton from '../../PreviewButton';

import AdvancedOptionsSection from './AdvancedOptionsSection';
import StartSendingCallout from './StartSendingCallout';

export default function GeneralSidebar() {
  return (
    <Box
      sx={{
        overflow: 'auto',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <Box p={3}>
        <SenderSelectField name="configuration.senderVerifiedEmailAddressId" label="From" variant="standard" />
        <TextField
          variant="standard"
          fullWidth
          size="small"
          margin="normal"
          name="configuration.subjectTemplate"
          label="Subject"
        />
        <TextField
          variant="standard"
          fullWidth
          size="small"
          margin="normal"
          name="configuration.preheaderTemplate"
          label="Preheader"
          InputProps={{
            endAdornment: (
              <Tooltip title="A preheader is the text following the subject line when an email is previewed.">
                <span>
                  <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
                </span>
              </Tooltip>
            ),
          }}
        />

        <AdvancedOptionsSection />
        <PreviewButton />
      </Box>
      <StartSendingCallout />
    </Box>
  );
}
